import {ProductEnum} from 'presentation/constants';

export const DS_ORIGIN = {
	[ProductEnum.HAP]: 'HAPVIDA',
	[ProductEnum.CCG]: 'CCG',
	[ProductEnum.CLINIPAM]: 'CLINIPAM',
	[ProductEnum.GNDI_MINAS]: 'GNDI_MINAS',
	[ProductEnum.GNDI]: 'GNDI_CORP',
	[ProductEnum.NOTREDAME_SAUDE]: 'GNDI_CORP',
};
